<script setup lang="ts">
const profile = usePortfolioStore().profile
const shapes = [
  { top: '34px', start: '6%', size: '14px', color: 'var(--t-accent)', anim: 'driftA 7s', radius: '99px' },
  { top: '72%', start: '10%', size: '11px', color: '#22c55e', anim: 'driftB 9s', radius: '99px' },
  { top: '52%', start: '68%', size: '9px', color: '#22c55e', anim: 'driftA 10s', radius: '99px' },
  { top: '28%', start: '60%', size: '8px', color: '#3b82f6', anim: 'driftB 6s', radius: '99px' },
  { top: '18%', start: '78%', size: '13px', color: '#3b82f6', anim: 'driftB 8s', radius: '3px' },
  { top: '64%', start: '86%', size: '10px', color: '#ef4444', anim: 'driftA 6.5s', radius: '3px' },
  { top: '40%', start: '3%', size: '11px', color: '#a855f7', anim: 'driftA 9.5s', radius: '2px', rotate: '45deg' },
  { top: '8%', start: '88%', size: '12px', color: 'var(--t-accent-2)', anim: 'driftB 7s', radius: '2px', rotate: '45deg' }
]
const triangles = [
  { top: '12%', start: '38%', color: '#f43f5e', anim: 'driftB 7.5s' },
  { top: '84%', start: '46%', color: 'var(--t-accent)', anim: 'driftA 8.5s' }
]
</script>

<template>
  <section id="hero" class="relative overflow-hidden bg-surface p-6 md:p-10 min-h-150">
    <span v-for="(s, i) in shapes" :key="i" aria-hidden="true" data-decor="true"
          class="pointer-events-none absolute"
          :style="{ top: s.top, insetInlineStart: s.start, width: s.size, height: s.size,
                    border: '2px solid ' + s.color, borderRadius: s.radius,
                    transform: s.rotate ? 'rotate(' + s.rotate + ')' : undefined,
                    animation: s.anim + ' ease-in-out infinite' }" />
    <span v-for="(t, i) in triangles" :key="'t' + i" aria-hidden="true" data-decor="true"
          class="pointer-events-none absolute h-0 w-0 opacity-80"
          :style="{ top: t.top, insetInlineStart: t.start,
                    borderInlineStart: '8px solid transparent', borderInlineEnd: '8px solid transparent',
                    borderBottom: '13px solid ' + t.color, animation: t.anim + ' ease-in-out infinite' }" />
    <!-- مکعب سه‌بعدی چرخان -->
    <div aria-hidden="true" data-decor="true" class="pointer-events-none absolute end-[42%] top-6 h-[34px] w-[34px] opacity-55
                                    [transform-style:preserve-3d] [animation:spin3d_12s_linear_infinite]">
      <span class="absolute inset-0 border-2 border-accent [transform:translateZ(17px)]" />
      <span class="absolute inset-0 border-2 border-accent [transform:rotateY(90deg)_translateZ(17px)]" />
      <span class="absolute inset-0 border-2 border-accent-2 [transform:rotateX(90deg)_translateZ(17px)]" />
    </div>

    <div class="grid items-center gap-6 md:grid-cols-2">
      <div>
        <h2 class="text-2xl font-extrabold leading-relaxed tracking-tight text-balance md:text-4xl">
          من <span class="text-accent">{{ profile?.fullname }}</span> هستم<br /><span class="font-bold text-muted">{{ profile?.job_title }}</span>
        </h2>
        <p class="mt-5 max-w-md text-[13.5px] leading-8 text-muted">{{ profile?.experience }}</p>
        <p class="mt-5 max-w-md text-[13.5px] leading-8 text-muted">{{ profile?.about }}</p>
        <p class="mt-5 max-w-md text-[13.5px] leading-8 text-muted">{{ profile?.quote }}</p>
        <a href="#contact"
           class="mt-6 inline-block rounded-lg bg-accent px-7 py-3.5 text-[13px] font-extrabold tracking-wide
                  text-bg-deep transition duration-300 hover:-translate-y-1 hover:scale-[1.02] hover:shadow-[var(--t-glow)]">
          استخدام من ←
        </a>
      </div>
      <img v-if="profile?.avatar" :src="profile.avatar" :alt="profile?.fullname"
           class="ms-auto aspect-[4/5] w-full max-w-[210px] rounded-[14px] bg-surface-2 object-cover [animation:floatY_7s_ease-in-out_infinite]" />
    </div>
  </section>
</template>
